export default __webpack_public_path__ + "static/media/Dock.d752d190.svg";